import { render, staticRenderFns } from "./CreateFlow.vue?vue&type=template&id=9b809e16&scoped=true&"
import script from "./CreateFlow.vue?vue&type=script&lang=js&"
export * from "./CreateFlow.vue?vue&type=script&lang=js&"
import style0 from "./CreateFlow.vue?vue&type=style&index=0&id=9b809e16&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b809e16",
  null
  
)

export default component.exports